import React, { useState } from 'react';
import Menu from 'material-ui/Menu';
import { IconButton, MenuItem } from '@material-ui/core';
import { MoreHoriz } from '@material-ui/icons';
import LastPerformanceBO from '../businessObjects/LastPerformanceBO';

const LastPerformanceMenu = props => {
    const {
        applyPrescription,
        savedWorkoutSetExercise,
        isSubscription
    } = props;
    const [anchorEl, setAnchorEl] = useState(null);

    const onClose = () => {
        setAnchorEl(null);
    };
    const onClick = event => {
        setAnchorEl(event.currentTarget);
    };

    if (isSubscription) {
        return null;
    }

    const repeatPerformance = () => {
        const prescription = LastPerformanceBO.createPrescription(
            savedWorkoutSetExercise
        );
        applyPrescription && applyPrescription(prescription);
        onClose();
    };

    return (
        <div className="lastPerformanceMenu">
            <IconButton onClick={onClick} aria-label="Last Performance Menu">
                <MoreHoriz />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={onClose}
            >
                <MenuItem onClick={repeatPerformance}>
                    Repeat This Performance
                </MenuItem>
            </Menu>
        </div>
    );
};

export default LastPerformanceMenu;



// WEBPACK FOOTER //
// ./src/v5/LastPerformance/components/LastPerformanceMenu.jsx